import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

export const HeadCell = styled.th.attrs(props => ({ 'data-qa': props.qa }))`
  text-align: left;
`;

HeadCell.propTypes = {
  qa: PropTypes.string
};

HeadCell.defaultProps = {
  qa: undefined
};

export const Cell = styled.td.attrs(props => ({ 'data-qa': props.qa }))`
  text-align: left;
  
  ${({
    theme
  }) => css`
    padding: ${theme.spacing[2]} 0 ${theme.spacing[2]} ${theme.spacing[4]};
  `};
`;

Cell.propTypes = {
  qa: PropTypes.string
};

Cell.defaultProps = {
  qa: undefined
};

export const Row = styled.tr.attrs(props => ({ 'data-qa': props.qa }))`
  ${({
    indent
  }) => indent && css`
    &, ${HeadCell}, ${Cell} {
      padding-top: 7px;
      vertical-align: middle;
    }
  `};
`;

Row.propTypes = {
  indent: PropTypes.bool,
  qa: PropTypes.string
};

Row.defaultProps = {
  indent: false,
  qa: undefined
};

export const TableBody = styled.tbody.attrs(props => ({ 'data-qa': props.qa }))``;

TableBody.propTypes = {
  qa: PropTypes.string
};

TableBody.defaultProps = {
  qa: undefined
};

export const TableHead = styled.thead.attrs(props => ({ 'data-qa': props.qa }))``;

TableHead.propTypes = {
  qa: PropTypes.string
};

TableHead.defaultProps = {
  qa: undefined
};

/**
 * @component
 * @tags styled, table
 */
export const Table = styled.table`
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  font-size: 13px;
  
  ${({
    theme
  }) => css`
    color: ${theme.colors.shades[0]};
  `};
`;
